import React from 'react';
import { 
  FaCrosshairs, 
  FaTextHeight, 
  FaTrash, 
  FaSearchPlus,
  FaSearchMinus,
  FaPaintBrush 
} from 'react-icons/fa';
import { 
  BsSlash, 
  BsDash, 
  BsGrid3X3 
} from 'react-icons/bs';

const DrawingToolbar = ({ activeTool, setActiveTool }) => {
  const tools = [
    { id: 'crosshair', icon: FaCrosshairs, label: 'Crosshair' },
    { id: 'trendline', icon: BsSlash, label: 'Trend Line' },
    { id: 'horizontal', icon: BsDash, label: 'Horizontal Line' },
    { id: 'fibonacci', icon: BsGrid3X3, label: 'Fibonacci Retracement' },
    { id: 'brush', icon: FaPaintBrush, label: 'Brush' },
    { id: 'text', icon: FaTextHeight, label: 'Text' },
    { id: 'zoomin', icon: FaSearchPlus, label: 'Zoom In' },
    { id: 'zoomout', icon: FaSearchMinus, label: 'Zoom Out' },
    { id: 'trash', icon: FaTrash, label: 'Clear All' },
  ];

  return (
    <div className="absolute left-3 top-3 z-10 bg-white rounded-lg shadow-lg border border-gray-200 p-1 flex flex-col space-y-1">
      {tools.map((tool) => {
        const Icon = tool.icon;
        return (
          <button
            key={tool.id}
            onClick={() => setActiveTool(tool.id)}
            className={`p-2 rounded transition-colors ${
              activeTool === tool.id
                ? 'bg-blue-600 text-white'
                : 'text-gray-700 hover:bg-gray-100'
            }`}
            title={tool.label}
          >
            <Icon className="text-base" />
          </button>
        );
      })}
    </div>
  );
};

export default DrawingToolbar;

